import StoryText from './Experience/StoryText'

const storyText = new StoryText()